module.exports = __webpack_public_path__ + "img/ring_r_l_0_0.65dca572.png";